var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',{staticClass:"text-center raleway page-head",style:({ marginBottom: '20px' })},[_vm._v("Opps")]),_vm._v(" "),_c('h4',{staticClass:"text-center raleway page-head",style:({ marginTop: '40px', marginBottom: '30px' })},[_vm._v("Nothing here...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13bfdd4e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoMatch.vue
// module id = null
// module chunks = 